/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iconik_Metadata_RequiredInputs */



/**
* | output |
* | --- |
* | "Required" |
*
* @param {Iconik_Metadata_RequiredInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_metadata_required = /** @type {((inputs?: Iconik_Metadata_RequiredInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Metadata_RequiredInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Required")
	if (locale === "de") return /** @type {LocalizedString} */ ("Required")
	if (locale === "it") return /** @type {LocalizedString} */ ("Required")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Required")
	if (locale === "es") return /** @type {LocalizedString} */ ("Required")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Required")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Required")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Required")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Required")
	return /** @type {LocalizedString} */ ("Required")
});